/* unplugin-vue-components disabled */import { render } from "./MockExam.vue?vue&type=template&id=5c660064"
import script from "./MockExam.vue?vue&type=script&lang=js"
export * from "./MockExam.vue?vue&type=script&lang=js"

import "./MockExam.vue?vue&type=style&index=0&id=5c660064&lang=scss"

import exportComponent from "../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__